import React from 'react';
import {IQuote} from "../../../../../../../../app/interfaces/quote/IQuote";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../../../../../../../../app/store";
import {selectCurrentUser} from "../../../../../../../../features/authentication/authenticationSliceSelectors";
import moment from 'moment'
import cl from './QuoteAvailableTill.module.css';

type QuoteAvailableTillProps = {
    quote: IQuote;
}

const QuoteAvailableTill: React.FC<QuoteAvailableTillProps> = ({
                                                                   quote
                                                               }) => {
    const {t} = useTranslation();
    const user = useAppSelector(selectCurrentUser);

    if (!user) {
        return null;
    }

    if (quote.availableTill === null) {
        return (
            <div className={'details-box-item-field-value'}>
                {" "}
            </div>
        );
    }

    let isWarn = moment.utc(quote.availableTill).toDate() <= moment().utc().toDate();

    return (
        <div className={`details-box-item-field-value ${isWarn ? cl.warn : cl.info}`}>
            <span >
                {moment.utc(quote.availableTill).local().format('DD.MM.YYYY HH:mm')}
            </span>
        </div>
    );
};

export default QuoteAvailableTill;
